import {EmbedCodeExtractor} from "./types"

/** Patterns of Tik::WebEmbedService::PreProcessor::JwPlayer (pre_processor/jwplayer.rb). */
const PATTERNS = [
  /<script src="?https:\/\/cdn\.jwplayer\.com\/players\/([a-zA-Z0-9-]+)\.js"?><\/script>/i,
  /div.*iframe src="?https:\/\/cdn\.jwplayer\.com\/players\/([a-zA-Z0-9_-]+)\.html"?.*\/div/i
]

/**
 * Converts JW Player `<script .../players/<id>.js>` snippets and iframe-in-div embed
 * codes to the canonical `https://cdn.jwplayer.com/players/<id>.html` player URL.
 */
export const jwPlayerPreProcessor: EmbedCodeExtractor = (input: string) => {
  for(const pattern of PATTERNS) {
    const match = pattern.exec(input)
    if(match) {
      return `https://cdn.jwplayer.com/players/${match[1]}.html`
    }
  }
  return null
}
